export default __webpack_public_path__ + "static/media/manajemen-asset-project.73ed4cc4.png";